var classes = {"container":"index-module_container__swmPI","small":"index-module_small__wJuu-","large":"index-module_large__MbnzI","skeleton":"index-module_skeleton__mizMC","smallLoading":"index-module_smallLoading__vo65J","largeLoading":"index-module_largeLoading__qUxGZ"};

export { classes as default };
//# sourceMappingURL=index.module.scss.js.map
